const SortIcon = (props) => {
    return (
        <>
            <i data-testid="sort-icon" className={(props.sort === 'descending') ? "bi bi-chevron-down" : "bi bi-chevron-up"}></i>
        </>
    )
}

export default SortIcon;